export const getCurrentDomain = () => {
  let domain = window.location.href.match(/^https?:\/\/[^/]+/i)[0];

  // ensure that if a local url is found its always localhost that's retrieved
  // (mostly to always match the correct circuit_url when logging as a pseudoanonymous)
  domain = domain.replace(/(0\.0\.0\.0|127\.0\.0\.1)/, "localhost");

  return domain;
};

export const isDashboardApp = () => {
  return getCurrentDomain() === import.meta.env.VITE_APP_URL;
};

export const isPublicApp = () => {
  return getCurrentDomain() !== import.meta.env.VITE_APP_URL;
};
